import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";
import { Link } from "react-router-dom";
import { FiArrowUpRight } from "react-icons/fi";
import Image from "./Image";
import ProjectArtwork from "./ProjectArtwork";

/**
 * Represents a project card component.
 *
 * @component
 * @param {object} project - A project from src/_data/projects.json.
 */

const ProjectCard = ({ project }) => {
  const [ref, inView] = useInView({
    threshold: 0.3,
    triggerOnce: true,
  });

  const variants = {
    hidden: { y: "10vw", opacity: 0 },
    visible: { y: 0, opacity: 1 },
  };

  return (
    <Link
      to={`/portfolio/${project.slug}`}
      className="projectLink col-12 col-lg-6"
      aria-label={`${project.title} — ${project.description}`}
    >
      <motion.article
        ref={ref}
        variants={variants}
        initial="hidden"
        animate={inView ? "visible" : "hidden"}
        transition={{ duration: 0.4, ease: "easeInOut" }}
      >
        <div
          style={{ backgroundColor: project.bgcolor }}
          className="projectCard d-flex align-items-center justify-content-center p-5"
        >
          <div className="textWrap col-6 d-flex flex-column justify-content-center align-items-center m-5">
            {project.demo && (
              <span className="liveBadge">
                <span className="liveDot" aria-hidden="true" /> Live demo
              </span>
            )}
            <span className="projectPlatforms">{project.platforms.join(" · ")}</span>
            <h3 className="projectTitle">{project.title}</h3>
            <p className="projectTagline">{project.description}</p>
            <span className="viewWork">
              View case study <FiArrowUpRight aria-hidden="true" />
            </span>
          </div>
          <div className="imageContainer col-6 d-flex align-items-center justify-content-center">
            {project.image ? (
              <Image src={project.image} alt={`${project.title} — ${project.description}`} />
            ) : (
              <ProjectArtwork project={project} />
            )}
          </div>
        </div>
      </motion.article>
    </Link>
  );
};

export default ProjectCard;
